import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, CircularProgress, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const DeleteRecordingModal = ({
  open,
  setOpen,
  recording_id,
  setRecordings,
  loader,
  setLoader
}) => {
    const [call_routes, setCallRoutes] = useState(null)
    

    const [auth, setAuth] = useState("");
  const getRoutes = async() => {
    setLoader(true)
      let routes = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "route/get-routes-using-rec-id",
          {
              primaryRecording:  recording_id,
              org_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
          }
        );
  
        setCallRoutes(routes.data.routes)
        setLoader(false)
        
  }
  
  useEffect(() => {
    getRoutes(
    )
  
}, [recording_id])
  
  console.log(JSON.parse(localStorage.getItem("organization")));

  const [twilio, setTwilio] = useState(
    JSON.parse(localStorage.getItem("organization")).twilio_integration
  );

  const deleteRecording = async () => {
      let check= await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
                      userId: JSON.parse(localStorage.getItem('user')).userId.S
                  });
                  
                  if (check.status === 200) {
                    const user___ = check.data.user;
                    
              
                    if(user___.relatedOrgs.L?.find((e)=> e?.M.org_id?.S === JSON.parse(localStorage.getItem('organization')).orgId.S)){
                      setLoader(true)
                      let recording = await axios.post(
                        process.env.REACT_APP_BACKEND_URL + "delete-recording",
                        {
                          rec_id: recording_id,
                          organization_id: JSON.parse(localStorage.getItem("organization")).orgId
                            .S,
                        }
                      );
                  
                      localStorage.setItem(
                        "organization",
                        JSON.stringify(recording.data.updatedItem)
                      );
                  
                      setRecordings(recording.data.updatedItem.recordings.L);
                      setLoader(false)
                      setOpen(false)
                        
                    }else{
                      window.location.reload()
                    }
          
                  }
  };
  const navigate = useNavigate()
  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"sm"}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
      }}
    >
      <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">
          Delete Recording!
        </div>

        {(call_routes && call_routes.length > 0) && (
            <div className="lg:text-[15px] text-[14px] text-center mt-2   mb-4">
            You have {call_routes && call_routes.length} call routes 
            ({call_routes.filter((e) => e)
  .map((e, index) => (
    <span onClick={()=> navigate('/dashboard/call-route/'+e.routeId.S) } key={index} className="text-blue-700 hover:underline cursor-pointer">
      {e.name.S}
    </span>
  ))
  .reduce((prev, curr) => [prev, ', ', curr])}) 
            currently using this recording. Please remove these dependencies before deleting this channel.
          </div>
        )}

        <div hidden = {call_routes && call_routes.length > 0 ? true : false}  className="lg:w-full my-3">
          <InputBase
            placeholder="Type DELETE to Confirm"
            value={auth}
            onChange={(e) => 
              setAuth(e.target.value)
            }
            sx={{
              bgcolor: "#F7F7F8",
              width: "100%",
              px: 2,
              py: 1,
              fontSize: { lg: "16px", xs: "14px" },
            }}
          />
        </div>
        <div className="flex justify-center">
          <div className="space-y-5 ">
            <div className="flex justify-center pt-6 pb-4 space-x-2">
              <Button
                sx={{
                  textTransform: "none",
                  color: "#605BFF",
                  bgcolor: "white",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  border: "1px solid rgba(96,91,255,0.1)",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </Button>


              {call_routes && call_routes.length > 0 ? (<></>) : (
              <Button
                sx={{
                  textTransform: "none",
                  bgcolor: "rgba(236,72,92,0.1)",
                  color: "rgba(236,72,92,1)",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                disabled={auth === "DELETE" ? false : true}
                onClick={() => {
                    deleteRecording()
                }}
              >
                {loader ? (
                  <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
                ) : (
                  " Delete"
                )}
              </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteRecordingModal;
